import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Shown when SSO succeeded but the user is not in Support or Admin (QA group 4).
 */
export function AccessDenied() {
  const { logout } = useAuth();

  const handleSignOut = async (): Promise<void> => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="login-page access-denied-page" data-testid="access-denied">
      <div className="login-card">
        <h1 className="login-title">Access denied</h1>
        <p className="login-subtitle">
          Your account is signed in, but it is not a member of the BCSupport or BCAdmin group
          required to use Commerce Intelligence.
        </p>
        <button className="btn-microsoft" type="button" onClick={() => void handleSignOut()}>
          Sign out
        </button>
      </div>
    </div>
  );
}
